<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-also-by element-with-heading" id="also-by-graham-smith">
<div class="heading heading-with-title heading-without-image" id="also-by-graham-smith-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Graham Smith</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-graham-smith-text">
<p class="first first-in-chapter first-full-width also-by-content">Jake Boulder Series</p>
<p class="subsq also-by-content">Watching The Bodies ( Book 1)</p>
<p class="subsq also-by-content">The Kindred Killers ( Book 2)</p>
<p class="subsq also-by-content">Past Echoes ( Book 3)</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-graham-smith.vue?2b169608